import * as React from "react";
const alliances = [{
  id: 1,
  name: "Quest Security",
  src: "https://talented-lamprey.10web.cloud/wp-content/uploads/2026/05/Klemm.png?v=aj9s0wkpmle"
}, {
  id: 2,
  name: "4 Star Protection",
  src: "https://talented-lamprey.10web.cloud/wp-content/uploads/2026/05/sokol-kockasti.jpg?v=qfd6691dw4"
}, {
  id: 3,
  name: "Security Force",
  src: "https://talented-lamprey.10web.cloud/wp-content/uploads/2026/05/supernova.png?v=khn3hp4fn4p"
}, {
  id: 4,
  name: "Elite Guarding",
  src: "https://talented-lamprey.10web.cloud/wp-content/uploads/2026/05/Z-centar.png?v=22hhv9zdxfr"
}, {
  id: 5,
  name: "Safe Haven",
  src: "https://talented-lamprey.10web.cloud/wp-content/uploads/2026/05/Franck.png?v=jnsng7wk22"
}, {
  id: 6,
  name: "Vanguard Security",
  src: "https://talented-lamprey.10web.cloud/wp-content/uploads/2026/05/Dukat.jpg?v=e42xoclk5eh"
}];
export default function StrategicAlliances() {
  return <section data-section-id="222631" id="povjerenje-vodećih-tvrtki" className="bg-background text-foreground py-16 md:py-24 border-y border-border/50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-10">
          <h2 className="font-default text-sm font-semibold uppercase tracking-widest text-muted-foreground text-center">TVRTKE KOJE VJERUJU MOBILEO SOFTVERU</h2>
          
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-10 md:gap-x-20 lg:gap-x-24">
            {alliances.map((alliance, i) => <div key={alliance.id} data-index={i} className="flex items-center justify-center">
                <img src={alliance.src} alt={`${alliance.name} logo`} className="h-8 md:h-10 w-auto object-contain grayscale opacity-50 transition-all duration-300 hover:grayscale-0 hover:opacity-100" loading="lazy" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}